import React from 'react';
import Layout from '../components/Layout'; // Importa o Layout
import Hero from '../components/Hero';
import Diferencial from '../components/Diferencial';
import Solucoes from '../components/Solucoes';
import Servicos from '../components/Servicos';
import Tecnologias from '../components/Tecnologias';
import Contato from '../components/Contato';
import { PageProps } from '../App'; // Importa a interface PageProps

// Adiciona PageProps à definição do componente
const HomePage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    // Passa as props para o Layout
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <Hero />
      <Diferencial />
      <Solucoes />
      <Servicos />
      <Tecnologias />
      <Contato />
    </Layout>
  );
};

export default HomePage;
